import { useState } from "react"
import DatePicker, { registerLocale } from "react-datepicker"
import es from "date-fns/locale/es"
import "react-datepicker/dist/react-datepicker.css"
import "../assets/styles/FloatingDatePicker.css"
import { useTranslation } from "react-i18next"

registerLocale("es", es)

/**
 * A date picker component with a floating label.
 *
 * @param {Object} props - Component props
 * @param {string} props.label - The label text
 * @param {Date} props.value - The selected date
 * @param {Function} props.onChange - Function called when date changes
 * @param {string} props.error - Error message
 * @param {boolean} props.touched - Whether the field has been touched
 * @param {boolean} props.required - Whether the field is required
 * @returns {JSX.Element} The FloatingDatePicker component
 */
const FloatingDatePicker = ({ label, value, onChange, error, touched, required }) => {
  const { t, i18n } = useTranslation()
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div
      className={`floating-input date-picker-wrapper ${isFocused || value ? "focused" : ""} ${error && touched ? "error" : ""} ${required ? "required" : ""}`}
    >
      <div className="datepicker-container">
        <DatePicker
          selected={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          dateFormat={t("floatingDatePicker.dateFormat")}
          placeholderText=" "
          className="ant-input custom-datepicker"
          locale={i18n.language}
        />
      </div>
      <label>
        {label}
        {required && "*"}
      </label>
    </div>
  )
}

export default FloatingDatePicker

